import React from "react";
import Cookies from "js-cookie";
import ContinueShopping from "../ContinueShopping/ContinueShopping";
import arrowNorthEast from "../../assets/images/icons/ic_arrow_northeast.svg";
import * as Styled from "./Style";

const Header = (props) => {
  return (
    // <section className="checkout-header">
    <Styled.HeaderStyle>
      <h2 className="section-title">Header</h2>
      <div className="container">
        <div className="row">
          <div className="col-7 col-lg-10">
            <Styled.MobileContinueShopping>
              <ContinueShopping path={props.path} />
            </Styled.MobileContinueShopping>
            <h1>
              {/* {props.customerId + " " + props.customerEmail + " "} */}
              {props.headerTitle + ""}
              {!props.isAdmin ? (
                props.itemCount != undefined ? (
                  <span>
                    {props.itemCount == 1
                      ? " (" + props.itemCount + " item)"
                      : props.itemCount > 1
                      ? " (" + props.itemCount + " items)"
                      : props.itemCount == 0
                      ? ""
                      : ""}
                  </span>
                ) : null
              ) : (
                ""
              )}
              {props.page == "bag" ? (
                <a
                  href="/shopping-help"
                  style={{ float: "right" }}
                  target="_blank"
                  className="shopping-help-link"
                >
                  Shopping help <img src={`${arrowNorthEast}`} alt="" />
                </a>
              ) : (
                ""
              )}
            </h1>
          </div>
          {
            // props.customerIsLoggedIn != 1 ||
            (props.customerIsGuest == 1 && props.customerIsGuest) || //if kk_guest is 1
            Cookies.get("KK_IS_GUEST") == 1 ||
            props.isGuestRegisterSuccess || //if guest successfully added an email
            !props.isUserRegistered ? (
              //if kk_customer_id is less than 0
              // display email section on Your Details
              <Styled.UserNameStyle className="col-5 col-lg-2">
                {props.page == "bag" ? (
                  <p>
                    {/* <button
                      onClick={props.signInPOC}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      Sign-In Modal POC
                    </button> */}
                    <a
                      href={props.signInLink}
                      // onClick={props.confirmRedirect}
                      onClick={props.signInLinkClick}
                    >
                      Sign in
                    </a>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <a
                      href={props.registerLink}
                      onClick={props.createLinkClick}
                    >
                      Create account
                    </a>
                  </p>
                ) : (
                  <p>
                    <a
                      href={props.signinAndCheckoutLink}
                      onClick={props.confirmRedirect}
                    >
                      Sign in
                    </a>
                  </p>
                )}
              </Styled.UserNameStyle>
            ) : (
              ""
            )
          }
        </div>
      </div>
    </Styled.HeaderStyle>
  );
};

export default Header;
